var BASE_MODULES = [];
var CORE_COMPONENTS = [];
var CoreModule = /** @class */ (function () {
    function CoreModule() {
    }
    return CoreModule;
}());
export { CoreModule };
